module.exports = ".introCard {\n  line-height: 30px;\n  margin-bottom: 20px; }\n\n.introCard .card-footer {\n  padding-top: 0px; }\n\nclr-vertical-nav-group-children {\n  margin-left: 15px; }\n\n.cm-heading {\n  max-width: 90%; }\n\n.disclaimer {\n  max-width: 95%; }\n\n.para {\n  max-width: 100%; }\n\n.hidden-sm-down-y {\n  background-color: #FFFFFF; }\n\n@media only screen and (min-width: 768px) {\n  .cm-heading {\n    max-width: 35%;\n    font-size: 15px;\n    text-align: justify; }\n  .disclaimer {\n    max-width: 95%; }\n  .para {\n    max-width: 90%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = ./src/app/home/home.component.scss
// module chunks = main